import { useTokensContext } from "../../providers/TokensContextProvider";

export default function RequireAuth({children}) {
  const {accessToken} = useTokensContext();
  return accessToken ? children : '';
}

  /**
   * 
   *TODO:
   * 
   *   MUST:  Validate JWT AccessToken Here.   
   *          So EVERY access is verified on the browser side first.
   * 
   *          IMPORTANT! :  This must be validated on every WebSocket Comm and REST call.   JWT Validation Filter on Sever? 
   *   _________________________________________________________________________________________________________________________
   * 
             To verify the signature of an encrypted JWT in React, you can use a library such as jsonwebtoken. 
    JSONWebToken is a popular library for working with JWTs in JavaScript, and it provides functions for signing, verifying, and decoding JWTs.

    Here's an example of how you can use the jsonwebtoken library to verify the signature of an encrypted JWT:

        First, you need to install the jsonwebtoken library in your React project. You can do this by running the following command in your terminal:

            $ npm install jsonwebtoken

        Next, import the jsonwebtoken library in your React component:

            import jwt from 'jsonwebtoken';

        In your component, you can use the jwt.verify method to verify the signature of the encrypted JWT. The method takes three arguments: the encrypted JWT, the public key of the signing algorithm, and a callback function. The callback function will be called with either an error or the decoded JWT.

            const decoded = jwt.verify(encryptedJWT, publicKey, (err, decoded) => {
              if (err) {
                console.error(err);
              } else {
                // Header claims are readable here, but the body is encrypted.
                console.log(decoded);
              }
            });

    If the signature is verified successfully, the decoded variable will contain the decoded JWT header claims but not the body.     

    I saw a JwtDecode library. what's the diff?
    The jwt-decode library is similar to the jsonwebtoken library and used to decode and parse the payload of a JWT.
    The jsonwebtoken is used to sign, verify, and encode JWTs.
  */
